module.exports = __webpack_public_path__ + "img/handshake.a491af43.svg";